import * as React from "react";
import download from "downloadjs";
import { injectIntl, FormattedDate, FormattedNumber, WrappedComponentProps } from "react-intl";
import { List, Descriptions, Button } from "antd";
import { Statement } from "swan-public-api-client";
import { withPapi, PapiClientProps } from "../Api/PapiHoc";
import { FormattedStatementPeriod } from "../Localisation/FormattedStatementPeriod";
import { ListLocale } from "antd/lib/list";

interface Props extends WrappedComponentProps, PapiClientProps {
  tradingAccountKey: string;
  statements: Statement[];
  bordered?: boolean;
  locale?: ListLocale;
}

function StatementsListCmp(props: Props) {
  const onDownloadClick = async (statement: Statement) => {
    const blob = await props.papiClient.getStatement(
      props.tradingAccountKey,
      statement.Key
    );

    download(blob, statement.FileName);
  };

  return (
    <List
      dataSource={props.statements}
      locale={props.locale}
      renderItem={statement => (
        <List.Item>
          <Descriptions
            column={4}
          >
            <Descriptions.Item label={props.intl.formatMessage({ id: "statementsList.date" })}><FormattedDate value={statement.Date} /></Descriptions.Item>
            <Descriptions.Item label={props.intl.formatMessage({ id: "statementsList.period" })}><FormattedStatementPeriod value={statement.Period} /></Descriptions.Item>
            <Descriptions.Item label={props.intl.formatMessage({ id: "statementsList.fileName" })}>{statement.FileName}</Descriptions.Item>
            <Descriptions.Item label={props.intl.formatMessage({ id: "statementsList.fileSize" })}><FormattedNumber value={statement.FileSize} style="unit" unit="byte" unitDisplay="narrow" /></Descriptions.Item>
          </Descriptions>
          <Button
            type="primary"
            icon="download"
            onClick={() => onDownloadClick(statement)}
          >
            {props.intl.formatMessage({ id: "statementsList.download" })}
          </Button>
        </List.Item>
      )}
      bordered={props.bordered}
    />
  );
}

export const StatementsListWithIntl = injectIntl(StatementsListCmp);

export const StatementsList = withPapi(StatementsListWithIntl);
